/* AdSenseBanner — renders an `<ins class="adsbygoogle">` unit and pushes it
   into the adsbygoogle queue once the DOM node is mounted. Requires the
   AdSense loader script (already in public/index.html head) and a slot id
   configured in your AdSense account.

   The slot prop is optional. If you leave it out, the AdSense script will use
   auto-ads sizing (useful while you configure dedicated slots). Display is
   hidden gracefully when REACT_APP_ADSENSE_CLIENT is not set. */
import React, { useEffect, useRef } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { isPaidSubscriber } from '@/lib/subscription';

export default function AdSenseBanner({
    slot,
    format = 'auto',
    layout,
    responsive = true,
    style,
    className = '',
    testId = 'adsense-banner',
}) {
    const { user } = useAuth();
    const client = process.env.REACT_APP_ADSENSE_CLIENT;
    const pushed = useRef(false);
    const adFree = isPaidSubscriber(user);

    useEffect(() => {
        if (!client || adFree || pushed.current) return;
        pushed.current = true;
        try {
            (window.adsbygoogle = window.adsbygoogle || []).push({});
        } catch (e) {
            // AdSense raises during dev HMR; harmless.
            console.warn('adsbygoogle push failed', e);
        }
    }, [client, adFree]);

    if (!client || adFree) return null;

    return (
        <ins
            className={`adsbygoogle ${className}`}
            data-testid={testId}
            style={{ display: 'block', ...style }}
            data-ad-client={client}
            {...(slot ? { 'data-ad-slot': slot } : {})}
            data-ad-format={format}
            {...(layout ? { 'data-ad-layout': layout } : {})}
            {...(responsive ? { 'data-full-width-responsive': 'true' } : {})}
        />
    );
}
